<p>event-ticket-table-filter works!</p>
